import { render, staticRenderFns } from "./RowMobileBlockSkeleton.vue?vue&type=template&id=1c37e040&"
import script from "./RowMobileBlockSkeleton.vue?vue&type=script&lang=js&"
export * from "./RowMobileBlockSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports